import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';
/**
 * Displays the current date and time and refreshes it every second
 */
export const DateTimeClock = () => {
    const [paused, setPaused] = useState(false);
    const [now, setNow] = useState(new Date());
    useEffect(() => {
        const timeout = window.setInterval(() => {
            if (paused) {
                return;
            }
            setNow(new Date());
        }, 1000);
        return () => {
            window.clearInterval(timeout);
        };
    }, [paused]);
    return (_jsxs("div", Object.assign({ className: clsx('text-2xl', paused && 'text-gray-300'), onDoubleClick: () => setPaused((val) => !val) }, { children: [_jsx(FormattedTime, { value: now }, void 0),
            _jsxs("span", Object.assign({ className: "font-light hidden md:inline-block" }, { children: ["\u00A0-\u00A0", _jsx(FormattedDate, { value: now, dateStyle: "full" }, void 0)] }), void 0)] }), void 0));
};
//# sourceMappingURL=DateTimeClock.js.map